import { createReducer, on } from '@ngrx/store';
import {
  CreateNewLiteralsChanged,
  LocaleLiteralCodeChanged,
  LocaleLiteralTextChanged,
  SubmitLocaleData,
} from '../actions/locale-literals.actions';
import { CreateNewLiteral, EditLiteral } from '../actions/search-literals.actions';
import { CloseLiteralsSidenav } from '../actions/sidenav.actions';

export interface LocaleLiteralsState {
  localeLiteralCode: string;
  localeLiteralText: string;
  isInEditView: boolean;
  languageId: number;
  languageCode: string;
  localeStringId: number;
  showLocaleLiteral: boolean;
  newLocaleLiterals: any[];
  isSubmittedData: boolean;
}

const initialState: LocaleLiteralsState = {
  localeLiteralCode: '',
  localeLiteralText: '',
  isInEditView: false,
  languageId: 0,
  languageCode: '',
  localeStringId: 0,
  showLocaleLiteral: false,
  newLocaleLiterals: [],
  isSubmittedData: false,
};

export const LocaleLiteralsReducer = createReducer(
  initialState,
  on(EditLiteral, (state, { row }) => ({
    ...state,
    localeLiteralCode: row.stringCode,
    localeLiteralText: row.localizedString,
    languageId: row.appLanguageId,
    languageCode: row.appLanguageCode,
    localeStringId: row.appLocaleStringId,
    isInEditView: true,
    showLocaleLiteral: true,
  })),
  on(LocaleLiteralCodeChanged, (state, { localeLiteralCode }) => ({
    ...state,
    localeLiteralCode,
  })),
  on(LocaleLiteralTextChanged, (state, { localeLiteralText }) => ({
    ...state,
    localeLiteralText,
  })),
  on(CreateNewLiteral, (state) => ({
    ...state,
    isInEditView: false,
    showLocaleLiteral: true,
    localeLiteralCode: '',
    localeLiteralText: '',
    languageId: 0,
    languageCode: '',
    localeStringId: 0,
    newLocaleLiterals: [],
    isSubmittedData: false,
  })),
  on(CreateNewLiteralsChanged, (state, { index, languageId, localizedString }) => {
    const updatedLocaleLiterals = [...state.newLocaleLiterals];

    updatedLocaleLiterals[index] = {
      languageId,
      localizedString,
    };

    return { ...state, newLocaleLiterals: updatedLocaleLiterals };
  }),
  on(SubmitLocaleData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(CloseLiteralsSidenav, (state) => ({
    ...state,
    isInEditView: false,
    showLocaleLiteral: true,
    localeLiteralCode: '',
    localeLiteralText: '',
    languageId: 0,
    languageCode: '',
    localeStringId: 0,
    newLocaleLiterals: [],
    isSubmittedData: false,
  })),
);
